import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button } from "reactstrap";
import {
  useGetCrmBankingDocumentsByIdQuery,
  useGetImagePathByIdQuery,
} from "features/onboarding/users/farmer/farmerApiSlice";
import Lightbox from "react-awesome-lightbox";
import { Table } from "react-bootstrap";
import "react-awesome-lightbox/build/style.css";
export const InsuranceDetailViewModal = ({
  serviceDetails,
  LeadsDataHalf,
  selectedProduct,
}) => {
  const [sendImagePath, setImagePath] = useState("");
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  let id = LeadsDataHalf?.user_id;
  const { data: documents } = useGetCrmBankingDocumentsByIdQuery(id, {
    skip: !id,
  });
  const { data: pathImage } = useGetImagePathByIdQuery(sendImagePath, {
    skip: !sendImagePath,
  });
  console.log("selectedProduct", selectedProduct);
  const showLargeImage = (imagePath) => {
    setImagePath(imagePath);
    setOpenLightBox(true);
  };
  useEffect(() => {
    if (pathImage) setImageInLightbox(pathImage.data.url);
  }, [pathImage]);

  const convertToTitleCase = (text) => {
    return text
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const renderDetail = (label, value) => (
    <div className="mt-3">
      <span style={{ color: "rgb(106 106 106)", fontWeight: "500" }}>
        {label} :{" "}
      </span>
      <span className="mt-1" style={{ color: "#333" }}>
        {value}
      </span>
    </div>
  );

  const handleDetailsDescription = (assetDetails, details, cattleDocuments) => {
    return (
      <>
        <div className="d-lg-block d-md-block d-none mt-3">
          <Table className="table mb-2" hover>
            <tbody>
              {[
                { label: "Cattle Owner", value: assetDetails.asset_owner },
                { label: "Cattle Type", value: assetDetails.asset_type },
                { label: "Cattle Species", value: details.cattle_species },
                { label: "Cattle Breed", value: details.cattle_breed },
                { label: "Cattle Age", value: details.cattle_age },
                { label: "Cattle Color", value: details.cattle_color },
                { label: "Cattle Pregnant", value: details.cattle_pregnant },
                {
                  label: "Cattle Milk Yield",
                  value: serviceDetails?.cattle_milkyield,
                },
                {
                  label: "Cattle Year Tag Number",
                  value: details.district_name,
                },
                {
                  label: "Cattle Tagging Date",
                  value: details?.cattle_ear_tag_num,
                },
                {
                  label: "Tagging Inspection Date",
                  value: details.cattle_tagging_date,
                },
                { label: "Cattle Left Horn", value: details.cattle_left_horn },
                {
                  label: "Cattle Right Horn",
                  value: details.cattle_right_horn,
                },
                {
                  label: "Cattle Sum Insured",
                  value: details.cattle_sum_insured,
                },
                {
                  label: "Cattle Switch Of Tail",
                  value: details.cattle_switchoftail,
                },
                { label: "Identification Mark", value: details.address },
                {
                  label: "Tagging Inspection Status",
                  value: details.doctor_tagging_inspection_current_status,
                  className: "fw-bold text-primary",
                },
              ]
                .reduce((rows, item, index, arr) => {
                  if (index % 3 === 0) {
                    rows.push([
                      item,
                      arr[index + 1] || { label: "", value: "" },
                      arr[index + 2] || { label: "", value: "" },
                    ]);
                  }
                  return rows;
                }, [])
                .map((row, index) => (
                  <tr key={index}>
                    {row.map((item, idx) => (
                      <React.Fragment key={idx}>
                        <th scope="row" className="align-middle">
                          {item.label}:
                        </th>
                        <td className={`align-middle ${item.className || ""}`}>
                          {item.value || "-"}
                        </td>
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>

          {/* Cattle Value and Market Value Section */}
          <div
            className="p-3 d-flex justify-content-between"
            style={{ background: "#f8f9fa", borderRadius: "8px" }}
          >
            <div className="text-center">
              <h6 className="mb-1 text-muted">Cattle Purchase Value</h6>
              <span className="fw-bold text-dark">
                ₹{assetDetails.asset_value}
              </span>
            </div>
            <div className="text-center">
              <h6 className="mb-1 text-muted">Cattle Current Market Value</h6>
              <span className="fw-bold text-success">
                ₹{details.doctor_market_value}
              </span>
            </div>
          </div>
        </div>

        {/* Cattle Documents Section */}
        {cattleDocuments.length > 0 && (
          <div className="mt-2">
            <div className="d-flex flex-wrap">
              {cattleDocuments.map((doc) => (
                <div
                  key={doc.id}
                  className="d-flex align-items-center p-2"
                  style={{
                    borderBottom: "1px solid #ddd",
                    paddingBottom: "6px",
                    gap: "10px",
                    cursor: "pointer",
                    transition: "background 0.2s ease-in-out",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "#f8f9fa")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                  onClick={() => showLargeImage(doc.path)}
                >
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                    width="50"
                    height="35"
                    style={{
                      borderRadius: "4px",
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                    alt="KYC Document"
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#555",
                    }}
                  >
                    {convertToTitleCase(doc?.media_type)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );
  };

  const handleServiceDetails = () => {
    if (JSON.stringify(serviceDetails) !== "{}") {
      if (
        serviceDetails?.cattle_data &&
        Array.isArray(serviceDetails?.cattle_data)
      ) {
        return serviceDetails?.cattle_data?.map((cattle, cattleIndex) => {
          const cattleDocuments =
            documents?.data
              ?.find(
                (category) => category.document_category === "Movable Assets"
              )
              ?.document_types?.find(
                (type) => type.document_type === "Cattle Images"
              )
              ?.documents?.filter(
                (doc) =>
                  doc.entity_id.toLowerCase() ===
                  (cattle.asset_details?.uniqueId || "").toLowerCase()
              ) || [];

          return (
            <div key={cattleIndex} className="row mb-1 mt-2 p-1">
              <div className="col-12 p-3">
                <h6
                  style={{
                    borderBottom: "1px solid #ddd",
                    paddingBottom: "6px",
                    fontWeight: "500",
                  }}
                >
                  Cattle Name : {cattle?.asset_name?.toUpperCase()}
                </h6>
                <div className="row">
                  {cattle.asset_details &&
                    handleDetailsDescription(
                      cattle,
                      cattle.asset_details,
                      cattleDocuments
                    )}
                </div>
              </div>
            </div>
          );
        });
      } else {
        if (
          selectedProduct === "CATTLE" ||
          serviceDetails.product_name === "Cattle"
        ) {
          const cattleDocuments = documents?.data
            ? documents.data
                .find(
                  (category) => category.document_category === "Movable Assets"
                )
                ?.document_types?.find(
                  (type) => type.document_type === "Cattle Images"
                )
                ?.documents?.filter(
                  (doc) =>
                    doc.filename &&
                    doc.entity_id.toLowerCase() ===
                      (serviceDetails?.uniqueId || "").toLowerCase()
                ) || []
            : [];

          return (
            <div className="row">
              <div className="row mb-1 mt-2 p-1">
                <div className="col-12 p-3">
                  <h6
                    style={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: "6px",
                      fontWeight: "500",
                    }}
                  >
                    Cattle Name : {serviceDetails?.asset_name?.toUpperCase()}
                  </h6>
                  <div className="row">
                    {handleDetailsDescription(
                      serviceDetails,
                      serviceDetails,
                      cattleDocuments
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div className="row">
              {Object.keys(serviceDetails).map((key, index) => (
                <Col key={index} md="3">
                  <div className="mt-3">
                    <span style={{ color: "rgb(106 106 106)" }}>
                      {convertToTitleCase(key)} :
                    </span>
                    <span className="mt-2" style={{ color: "#333" }}>
                      {serviceDetails[key] || "-"}
                    </span>
                  </div>
                </Col>
              ))}
            </div>
          );
        }
      }
    }
  };

  return (
    <>
      <Row className="">
        <Col md={12} lg={12}>
          <div
            style={{
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.008)",
              marginBottom: "20px",
              backgroundColor: "white",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "10px",
              }}
            >
              <h6 style={{ fontWeight: "600", margin: 0 }}>
                APPLICANT DETAILS
              </h6>
              <span
                style={{
                  backgroundColor: "#27ae60",
                  color: "white",
                  padding: "6px 12px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {LeadsDataHalf.current_status}
              </span>
            </div>

            <div className="d-lg-block d-md-block d-none mt-3">
              <Table className="table mb-2" hover>
                <tbody>
                  {[
                    {
                      label: "Name",
                      value: `${LeadsDataHalf.first_name} ${LeadsDataHalf.last_name}`,
                    },
                    { label: "Gender", value: LeadsDataHalf.gender },
                    { label: "DOB", value: LeadsDataHalf.DOB },
                    { label: "Age", value: LeadsDataHalf.age },
                    { label: "Mobile", value: LeadsDataHalf.phone_number },
                    { label: "Email", value: LeadsDataHalf.email },
                    { label: "State", value: LeadsDataHalf.state_name },
                    { label: "District", value: LeadsDataHalf.district_name },
                    { label: "Block", value: LeadsDataHalf.block_name },
                    { label: "Pincode", value: LeadsDataHalf.pincode },
                    { label: "Address", value: LeadsDataHalf.address },
                  ]
                    .reduce((rows, item, index, arr) => {
                      if (index % 2 === 0) {
                        rows.push([
                          item,
                          arr[index + 1] || { label: "", value: "" },
                        ]);
                      }
                      return rows;
                    }, [])
                    .map((row, index) => (
                      <tr key={index}>
                        {row.map((item, idx) => (
                          <React.Fragment key={idx}>
                            <th scope="row" className="align-middle">
                              {item.label}:
                            </th>
                            <td className="align-middle">
                              {item.value || "-"}
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>

            {selectedProduct === "CATTLE" ? (
              <div
                className="d-flex align-items-center mt-3"
                style={{
                  paddingTop: "12px",
                  fontSize: "14px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "30px",
                  paddingBottom: "6px",
                }}
              >
                {[
                  { label: "KYC Status", key: "kyc_status", type: "object" },
                  {
                    label: "Proposal Form",
                    key: "proposal_form",
                    type: "object",
                  },
                  {
                    label: "Inspection Status",
                    key: "doc_proposal_status",
                    type: "boolean",
                  },
                  {
                    label: "Policy Issued",
                    key: "policy_issued",
                    type: "boolean",
                  },
                ].map((statusItem, index) => {
                  let statusValue =
                    statusItem.type === "object"
                      ? LeadsDataHalf?.lead_details?.[0]?.service_details?.[
                          statusItem.key
                        ]?.status
                      : LeadsDataHalf?.lead_details?.[0]?.service_details?.[
                          statusItem.key
                        ];

                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: "#f8f9fa",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        minWidth: "200px",
                      }}
                    >
                      <strong style={{ minWidth: "140px", color: "#333" }}>
                        {statusItem.label}:
                      </strong>
                      <span
                        style={{
                          color: statusValue ? "green" : "red",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginLeft: "8px",
                        }}
                      >
                        {statusValue ? "☑️" : "❌"}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}

            {selectedProduct === "CATTLE" ? (
              <div
                className="row mt-2"
                style={{
                  borderBottom: "1px dashed #ddd",
                  paddingBottom: "6px",
                }}
              >
                <div className="col-6 d-flex">
                  <strong style={{ minWidth: "160px" }}>Policy URL:</strong>
                  {LeadsDataHalf?.lead_details?.length > 0
                    ? LeadsDataHalf.lead_details[0]?.service_details?.policy_url
                    : "-"}
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="mt-3">
              <h6
                style={{
                  fontWeight: "600",
                  marginBottom: "16px",
                  color: "#333",
                }}
              >
                KYC Documents
              </h6>
              <div className="d-flex  gap-2">
                {documents?.data?.flatMap((category) =>
                  category?.document_types?.flatMap((docType) =>
                    docType?.documents?.map((doc) =>
                      category.document_category.toLowerCase() ===
                      "kyc documents" ? (
                        <div
                          key={doc.id}
                          className="d-flex align-items-center p-2"
                          style={{
                            borderBottom: "1px solid #ddd",
                            paddingBottom: "6px",
                            gap: "10px",
                            cursor: "pointer",
                            transition: "background 0.2s ease-in-out",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.background = "#f8f9fa")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                          onClick={() => showLargeImage(doc.path)}
                        >
                          <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                            width="50"
                            height="35"
                            style={{
                              borderRadius: "4px",
                              objectFit: "cover",
                              flexShrink: 0,
                            }}
                            alt="KYC Document"
                          />
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#555",
                            }}
                          >
                            {convertToTitleCase(doc?.media_type)}
                          </span>
                        </div>
                      ) : null
                    )
                  )
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "15px",
          boxShadow: "0 1px 5px rgba(0, 0, 0, 0.008)",
          marginBottom: "20px",
        }}
      >
        <h6
          style={{
            color: "",
            borderBottom: "1px solid #ddd",
            paddingBottom: "6px",
            fontWeight: "500",
          }}
        >
          {selectedProduct} DETAILS
        </h6>
        <div className="row">{handleServiceDetails()}</div>
      </div>

      {/* <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "15px",
          boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)",
          marginBottom: "20px",
        }}
      >
        <h6
          style={{
            color: "",
            borderBottom: "1px solid #ddd",
            paddingBottom: "6px",
            fontWeight: "500",
            marginBottom: "20px",
          }}
        >
          KYC Documents
        </h6>
        <div className="d-flex flex-wrap">
          {documents?.data?.map((category, categoryIndex) =>
            category?.document_types?.map((docType, typeIndex) =>
              docType?.documents?.map((doc, docIndex) => (
                <div key={doc.id} className="p-2">
                  {category.document_category.toLowerCase() ===
                    "kyc documents" && (
                    <Card>
                      <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
                        width="60"
                        height="40"
                        className="cursor-pointer"
                        onClick={() => showLargeImage(doc.path)}
                      />
                      <div
                        className="mt-2 text-muted text-center"
                        style={{ fontSize: "12px" }}
                      >
                        {convertToTitleCase(doc?.media_type)}
                      </div>
                    </Card>
                  )}
                  {openLightbox && (
                    <Lightbox
                      image={lightBoxViewImage}
                      title="Image Title"
                      onClose={() => setOpenLightBox(false)}
                    />
                  )}
                </div>
              ))
            )
          )}
        </div>
      </div> */}
    </>
  );
};
